import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {MatSidenav} from '@angular/material';

@Component({
  selector: 'app-ecare-parent',
  templateUrl: './ecare-parent.component.html',
  styleUrls: ['./ecare-parent.component.css']
})
export class EcareParentComponent implements OnInit, OnDestroy {

  showFiller = false;
  slideIn = true;
  @ViewChild('drawer') drawer: MatSidenav;
  constructor(private router: Router,
              private activatedRoute: ActivatedRoute) {
    this.router.events.subscribe((event)  => {
      if (event instanceof NavigationEnd) {
        if(this.activatedRoute.snapshot.firstChild.data.title === 'Live Data') {
          this.showFiller = true;
        } else {
          this.showFiller = false;
        }
        /*if (!this.slideIn && this.activatedRoute.snapshot.firstChild.data.title !== 'Live Data') {
          this.drawer.toggle().then();
        }*/
      }
    });
  }

  ngOnInit() {
  }

  toggleIcon(state) {
    this.slideIn = !state;
  }

  public ngOnDestroy() {

  }
}
